module.exports =
  memberAccount: ->
    `import(/* webpackChunkName: "member-account-view" */'views/member/member-account-view')`
  memberBilling: ->
    `import(/* webpackChunkName: "member-billing-view" */'views/member/member-billing-view')`
  memberCards: ->
    `import(/* webpackChunkName: "member-cards-view" */'views/member/member-cards-view')`
  memberProfile: ->
    `import(/* webpackChunkName: "member-profile-view" */'views/member/member-profile-view')`



// WEBPACK FOOTER //
// ./app/scripts/controller/member-routes-view-loaders.coffee